import { z } from 'zod'

import { auditShape } from '@/shared/details'

export * from './paths'

const userGroupSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    organizationId: z.string(),
    organizationName: z.string(),
    companyId: z.string().nullish(),
    companyName: z.string().nullish(),
  })
  .extend(auditShape)

/** A user group as its details page and edit form show it. */
export type UserGroup = z.infer<typeof userGroupSchema>

export function parseUserGroup(body: unknown): UserGroup {
  return userGroupSchema.parse(body)
}

const summarySchema = z.object({
  id: z.string(),
  name: z.string(),
  organizationId: z.string(),
  organizationName: z.string(),
  companyId: z.string().nullish(),
  companyName: z.string().nullish(),
})

/** A user group as Find User Groups and the chooser show it. */
export type UserGroupSummary = z.infer<typeof summarySchema>

export function parseUserGroupSummary(item: unknown): UserGroupSummary {
  return summarySchema.parse(item)
}

const memberSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  email: z.string().nullish(),
})

/** A member as Group Details lists them. */
export type UserGroupMember = z.infer<typeof memberSchema>

export function parseUserGroupMember(item: unknown): UserGroupMember {
  return memberSchema.parse(item)
}

const addedSchema = z.object({
  added: z.array(z.string()),
  alreadyMembers: z.array(z.string()),
  refused: z.array(z.string()),
})

/** What adding people did: who joined, who was already in, and who may not join. */
export type MembersAdded = z.infer<typeof addedSchema>

export function parseMembersAdded(body: unknown): MembersAdded {
  return addedSchema.parse(body)
}

const removedSchema = z.object({ removed: z.array(z.string()) })

export function parseMembersRemoved(body: unknown): readonly string[] {
  return removedSchema.parse(body).removed
}
